<div class="auth-fluid">
    <div class="auth-fluid-form-box">
        <div class="align-items-center d-flex h-100">
            <div class="card-body">

                <div
                    class="auth-brand text-center"
                    [class.branch-mode]="showBranchSelector"
                    [style.transform]="showBranchSelector ? 'translateY(-' + getLogoLiftPx() + 'px)' : null">
                    <a class="logo-dark">
                        <span><img #companyLargeLogoRef [src]="" alt="" height="80"></span>
                    </a>
                    <a class="logo-light">
                        <span><img #companySmallLogoRef [src]="" alt=""
                                height="18"></span>
                    </a>
                </div>

                <ng-container *ngIf="!showBranchSelector">

                    <h4 class="mt-0">Log In</h4>
                    <p class=" mb-4">Enter your email address and password to access account.</p>

                    <div class="alert alert-danger" role="alert" #loginErrorRef style="display: none;">

                    </div>

                    <form *ngIf="formVisible" [formGroup]="LoginForm" (ngSubmit)="loginUser()">
                        <div *ngIf="selectedCompanyId == 0" class="mb-3">
                            <label for="Company" class="form-label">Select Company</label>
                            <ng-select id="Company" [items]="companyList" bindLabel="cName" bindValue="tenantId"
                                [loading]="companyLoading" formControlName="companyId" (search)="onNgSearch($event)" (change)="onCompanyPicked($event)">
                            </ng-select>
                        </div>
                        <div class="mb-3">
                            <label for="Username" class="form-label">Username</label>
                            <input class="form-control" type="email" id="Username" required=""
                                placeholder="Enter your Username" formControlName="userName">
                        </div>
                        <div class="mb-3">
                            <label for="password" class="form-label">Password</label>
                            <input class="form-control" type="password" required="" id="password"
                                placeholder="Enter your password" formControlName="password">
                            <a href="forgotPass.html" class=" float-end"><small>Forgot your password?</small></a>
                        </div>

                        <div class="d-grid mb-0 text-center">
                            <button class="btn btn-primary" type="submit"><i class="mdi mdi-login"></i> Log In
                            </button>
                        </div>

                    </form>


                    <footer class="footer footer-alt">
                        <p class="">Don't have an account? <a href="SignUp.html" class=" ms-1"><b>Sign Up</b></a>
                        </p>
                    </footer>
                </ng-container>


                <ng-container *ngIf="showBranchSelector">
                    <section class="branch-selector">
                        <div class="branch-selector-header">
                            <h4 class="mt-0 mb-1">Select Branch</h4>
                            <p class="text-muted mb-0">Choose where you want to Login.</p>
                        </div>

                        <div class="branch-grid">
                            <button
                                type="button"
                                class="branch-card"
                                *ngFor="let branch of BranchList"
                                (click)="selectBranch(branch)"
                                [class.default-branch]="branch.isDefault === 1">
                                <div class="branch-card-main">
                                    <span class="branch-icon-chip" aria-hidden="true">
                                        <i class="mdi mdi-domain"></i>
                                    </span>

                                    <div class="branch-card-content">
                                        <div class="branch-card-head">
                                            <span class="branch-code">{{ branch.branchCode }}</span>
                                        </div>
                                        <div class="branch-name">{{ branch.branchName }}</div>
                                    </div>

                                    <span class="branch-badge branch-badge-mid" *ngIf="branch.isDefault === 1">Default</span>

                                    <span class="branch-forward" aria-hidden="true">
                                        <i class="mdi mdi-chevron-right"></i>
                                    </span>
                                </div>
                            </button>
                        </div>
                    </section>
                </ng-container>


            </div>
        </div>
    </div>



    <div class="auth-fluid-right text-center" #companyCover>
        <div
            style="position: absolute; inset: 0; background: url('assets/images/bg-auth.jpg'); z-index: 0;background-size: cover;">
        </div>
        <div class="auth-user-testimonial">
            <h2 class="mb-3">Textile business operating application</h2>
            <p class="lead">
                asasdasdasdsadsad
            </p>
        </div>
    </div>
    
</div>


